import { inject, Injectable } from '@angular/core';
import { AnotaToastService, Toast } from '@githubanotaai/design-system';

@Injectable({
  providedIn: 'root',
})
export class ToastStore {
  private anotaToastService = inject(AnotaToastService);

  show(toast: Toast) {
    this.anotaToastService.addToast(toast);
  }
}
